module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.SitePage_Join":{"widgets.customJoin.handleWom.togglePreloader.widget":[{"value":"#prepareTransactionApi","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107006},"path":"~.SitePage_Join","_fox_":1}],"widgets.customJoin.handleWom.togglePreloader.event":[{"value":["prepare","success","failure"],"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107007},"path":"~.SitePage_Join","_fox_":1}],"widgets.customJoin.handleWom.togglePreloader.callback":[{"value":function (obj, api, e) {
var el = $('.submit .small-loader')
if (e == 'prepare') {
el.addClass('spin');
return
}
el.removeClass('spin')
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107015},"path":"~.SitePage_Join","_fox_":1}],"widgets.customJoin.handleDom.nextPrev.target":[{"value":".arr","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107018},"path":"~.SitePage_Join","_fox_":1}],"widgets.customJoin.handleDom.nextPrev.event":[{"value":"click","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107019},"path":"~.SitePage_Join","_fox_":1}],"widgets.customJoin.handleDom.nextPrev.callback":[{"value":function (el) {
var slider = this.wom1('#joinOptions').swipe;
var dir = fox.dom.wrap(el).attr('data-direction');
if (dir == 'next') {
slider.next()
return;
}
slider.prev();
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107028},"path":"~.SitePage_Join","_fox_":1}],"widgets.customJoin.widgets.pager.widget":[{"value":"Widget","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107031},"path":"~.SitePage_Join","_fox_":1}],"widgets.customJoin.widgets.pager.container":[{"value":".bullets","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107032},"path":"~.SitePage_Join","_fox_":1}],"widgets.customJoin.widgets.pager.autoRender":[{"value":false,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107033},"path":"~.SitePage_Join","_fox_":1}],"widgets.customJoin.widgets.pager.template":[{"value":"sitepage_join_form_pager","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107034},"path":"~.SitePage_Join","_fox_":1}],"widgets.customJoin.widgets.joinOptions.hooks.onStopAddedToDom":[{"value":function () {
var options = fox.getEnv('siteProps.ubs.joinOptions.options');
var pager = this.getParent().rwom1('#pager')
var arr = [];
var w = this;
var i;
var maxDiscount = this.getOption('maxDiscount');
var discountPosition = false;
fox.each(options, function (opt, n) {
data = {i: n};
if (fox.Navigator.get(0) == 'upgrade' && !!(opt.discountParams.length > 0)){
var curDiscount = Math.trunc(opt.discountParams.discount);
if (curDiscount == maxDiscount){
discountPosition = n;
i = n;
data.active = true;
var form = w.rwom1('@parent #form');
var chkbx = fox.dom.selectFirst('#joinOption_' + opt.id);
if (!form.ready) {
arr.push(data);
return w.getParent().wait(form, 'form_ready').then(function () {
form.setValue(chkbx.name, chkbx.value);
});
} else {
form.setValue(chkbx.name, chkbx.value);
}
}
} else {
if (opt['default']) {
i = n;
data.active = true
}
}
arr.push(data);
});
this.swipe = (Swipe)(w.getParent().dom1('#swipe'), {
startSlide: i,
callback: function (ind, el) {
var arr = [];
var chkbx = fox.dom.selectFirst('input[type="radio"]', el);
w.rwom1('@parent #form').setValue(chkbx.name, chkbx.value);
fox.each(options, function (opt, n) {
var data = {i: n};
if (opt.settings.id == chkbx.value) {
data.active = true
}
arr.push(data)
});
pager.setTemplateOptions({bullets: arr}).render()
}
});
if (!!discountPosition){
this.swipe.slide(discountPosition, 0)
}
pager.setTemplateOptions({bullets: arr}).render()
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107093},"path":"~.SitePage_Join","_fox_":1}],"handleWom.errorOnPrepare.event":[{"value":"onPrepareFailed","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107097},"path":"~.SitePage_Join","_fox_":1}],"handleWom.errorOnPrepare.widget":[{"value":"#customJoin","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107098},"path":"~.SitePage_Join","_fox_":1}],"handleWom.errorOnPrepare.params.prefix":[{"value":"new_autumn","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107099},"path":"~.SitePage_Join","_fox_":1}],"handleWom.errorOnPrepare.callback":[{"value":function (params, performer) {
var form, fEl, lError, code;
form = performer.rwom1('#form');
code = params.code;
if (fox.isEmpty(params.data) && !fox.isSet(code)) {
params.data = {
username: [
{message: params.reason}
]
}
}
switch(code) {
case 12:
case 101:
params.data = {
email: [
{message: params.reason}
]
}
break;
case 2:
params.data = {
username: [
{message: 'User with such login already exists'}
]
}
break;
}
fox.each(params.data, function (val, key) {
if (key === 'username') {
key = 'login';
}
fEl = form.getElement(key).nodes[0];
lError = jQuery(fEl).next();
lError.text(val[0].message).addClass('show');
if (fEl) {
fox.dom.addClass('error', fEl);
fox.dom.on('focus', fEl, function () {
fox.dom.removeClass('error', this);
$(this).next().text('').removeClass('show')
});
}
});
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107143},"path":"~.SitePage_Join","_fox_":1}],"hooks.onStartRendering":[{"value":function () {
var txtLogo = fox.objectGet(fox.dictionary, 'phrases.logoText.default');
if (txtLogo) {
var length = fox.trim(txtLogo.replace(new RegExp('&nbsp;', "g"), String.fromCharCode(160))).length;
if (length > 20) {
this.setTemplateOptions({
showDefaultMobileLogo: true
})
}
}
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107156},"path":"~.SitePage_Join","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ./options/sitepage/join.js
// module id = 1155
// module chunks = 4